module.exports = __webpack_public_path__ + "img/3-3.63a3875d.svg";